import { InjectionToken } from '@angular/core';

export const SUGGESTED_AMOUNT_SERVICE_ENTITY_CONFIG = new InjectionToken<string>(
  'suggested.amount.service.entity.config'
);
